export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["क्रिप्टो आईडी:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["भाषा"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["शुभ प्रभात"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["शुभ दोपहर"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["शुभ संध्या"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["शुभ रात्रि"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["लॉग आउट"])}
}